export default "__VITE_ASSET__mMkQw4Ng__"